export const ndaResendCooldownMs = 15 * 60 * 1000;

const ndaResendCooldownStorageKeyPrefix = "xboxOnboardNdaResendCooldown";

const getNdaResendCooldownStorageKey = (userEmail: string): string =>
  `${ndaResendCooldownStorageKeyPrefix}:${userEmail.toLowerCase()}`;

type NdaResendCooldownStorage = Pick<Storage, "getItem" | "setItem" | "removeItem">;

export const getNdaResendAvailableAt = (
  storage: NdaResendCooldownStorage,
  userEmail: string,
  now = Date.now()
): number | null => {
  const storageKey = getNdaResendCooldownStorageKey(userEmail);
  const availableAt = Number(storage.getItem(storageKey));

  if (!Number.isFinite(availableAt)) {
    storage.removeItem(storageKey);
    return null;
  }

  return availableAt > now ? availableAt : null;
};

export const startNdaResendCooldown = (
  storage: NdaResendCooldownStorage,
  userEmail: string,
  now = Date.now()
): number => {
  const availableAt = now + ndaResendCooldownMs;
  storage.setItem(getNdaResendCooldownStorageKey(userEmail), String(availableAt));
  return availableAt;
};

export const startInitialNdaResendCooldown = (
  storage: NdaResendCooldownStorage,
  userEmail: string,
  now = Date.now()
): number | null => {
  const storageKey = getNdaResendCooldownStorageKey(userEmail);
  const storedValue = storage.getItem(storageKey);
  const availableAt = Number(storedValue);

  if (storedValue === null || !Number.isFinite(availableAt)) {
    return startNdaResendCooldown(storage, userEmail, now);
  }

  return availableAt > now ? availableAt : null;
};

export const clearNdaResendCooldown = (
  storage: NdaResendCooldownStorage,
  userEmail: string
): void => {
  storage.setItem(getNdaResendCooldownStorageKey(userEmail), "0");
};
